export const RECOMMENDATION_STATES = 9663311124621;
export const SOIL_MOISTURE_CUT_OFFS = 9663214721037;
export const SEQUENTIAL_IRRIGATION = 9662637739149;
export const CROP_HEALTH = 13514640320397;
